export const housekeeping = {
  // ── الصفحة (index) ──
  title: "التنظيف",
  remindersBtn: "التذكيرات",
  refresh: "تحديث",
  aboutToLeaveTitle: "نزلاء على وشك المغادرة اليوم",
  aboutToLeaveCount: "{count} على وشك المغادرة",
  remindersTitle: "إعداد تذكيرات التنظيف",

  headline: {
    allDone: "كل شيء محدَّث! لا يوجد ما يحتاج إلى تنظيف الآن.",
    inProgress: "التنظيف جارٍ · {count} قيد التنفيذ",
    toClean: "ما الذي يحتاج إلى تنظيف اليوم؟ {count} بحاجة إلى تنظيف",
    toCleanWithProgress: "ما الذي يحتاج إلى تنظيف اليوم؟ {toClean} بحاجة إلى تنظيف · {inProgress} قيد التنفيذ",
  },

  allProperties: "جميع العقارات",
  searchPlaceholder: "ابحث عن غرفة أو نزيل…",

  // شرائح التصفية حسب الحالة (التسمية)
  chips: {
    all: "الكل",
    to_clean: "بحاجة إلى تنظيف",
    in_progress: "قيد التنفيذ",
    occupied: "مشغولة",
    clean: "متاحة",
    out_of_service: "خارج الخدمة",
  },
  // شرائح التصفية حسب الحالة (تلميح)
  chipTips: {
    all: "جميع مساحات اليوم، دون تصفية.",
    to_clean: "بانتظار التنظيف: المعلَّمة كمتّسخة، أو التي بها مغادرة اليوم دون تنظيف، أو الإقامات الطويلة التي حان موعد تنظيفها وفق الفترة المحددة.",
    in_progress: "التنظيف جارٍ الآن.",
    occupied: "بها نزيل (إقامة جارية، لا يغادر اليوم).",
    clean: "نظيفة وجاهزة للنزيل التالي (تشمل التي تم تفتيشها).",
    out_of_service: "غير متاحة للتنظيف (عطل أو صيانة).",
  },

  loadingBoard: "جارٍ تحميل اللوحة…",
  emptyToClean: "كل شيء نظيف! لا توجد مساحات معلّقة الآن.",
  emptyStatus: "لا توجد مساحات بهذه الحالة.",
  emptySearch: "لا توجد مساحات تطابق البحث.",

  typeHotel: "فندق",
  typeApartment: "شقة",

  // شارات الصف
  stayDue: "حان وقت التنظيف",
  hourlyStayDue: "انتهت إقامة بالساعة",
  hourlyStayAt: "غادر في {time}",
  overdue: "متأخرة",
  overdueSince: "لم تُنظّف منذ {date} · {days} يومًا",
  overdueGuests: "غادر {n} نزلاء دون تسجيل تنظيف",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "من {from} إلى {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "تجاوز الوقت",
  alreadyLeft: "غادر بالفعل",
  aboutToLeave: "على وشك المغادرة",
  cleanBadge: "نظيفة",
  inspectedBadge: "تم التفتيش",

  // التبديل (يغادر أحدهم / يصل آخر)
  departs: "↑ يغادر",
  arrives: "↓ يصل",
  guestFallback: "نزيل",
  departsOn: "· يغادر {date}",

  // إجراءات الصف
  assign: "إسناد",
  reassignTitle: "إعادة إسناد من يتولى التنظيف",
  assignWhoTitle: "إسناد من يتولى التنظيف",
  start: "بدء",
  startTitle: "تعليم كقيد التنفيذ",
  cleanAction: "نظيفة",
  cleanTitle: "إكمال التنظيف (صور وملاحظات)",
  tasks: "المهام",
  tasksTitle: "المهام والتفاصيل",

  toastSaved: "تم تحديث تذكيرات التنظيف",

  // الحالة الفعلية (التسمية)
  status: {
    to_clean: "بحاجة إلى تنظيف",
    in_progress: "قيد التنفيذ",
    occupied: "قيد الاستخدام",
    clean: "متاحة",
    inspected: "تم التفتيش",
    out_of_service: "خارج الخدمة",
  },
  // الحالة الفعلية (تلميح)
  statusTip: {
    to_clean: "بانتظار التنظيف.",
    in_progress: "التنظيف جارٍ.",
    occupied: "قيد الاستخدام: النزيل بالداخل.",
    clean: "نظيفة وجاهزة للنزيل التالي.",
    inspected: "نظيفة وتم التحقق منها بواسطة مشرف.",
    out_of_service: "خارج الخدمة: لا يمكن تنظيفها (عطل/صيانة).",
  },
  // الإشغال (التسمية)
  occupancy: {
    vacant: "شاغرة",
    occupied: "مشغولة",
    departure_today: "تغادر اليوم",
    arrival_today: "تصل اليوم",
    turnover: "مغادرة ووصول",
  },
  // الإشغال (تلميح)
  occupancyTip: {
    vacant: "بدون نزيل: شاغرة.",
    occupied: "نزيل بالداخل (إقامة جارية).",
    departure_today: "النزيل يغادر اليوم: ستحتاج إلى تنظيف.",
    arrival_today: "يصل نزيل اليوم: يجب أن تكون جاهزة في الوقت المناسب.",
    turnover: "يغادر نزيل ويصل آخر اليوم: تنظيف عاجل بينهما.",
  },

  roles: {
    limpieza: "التنظيف",
    mantenimiento: "الصيانة",
    recepcion: "الاستقبال",
    gestor: "مدير",
    propietario: "المالك",
  },

  // سبب التنظيف في منتصف الإقامة
  stayTip: {
    fallback: "حان موعد تنظيف الإقامة",
    daysSince: "{count} يوم | {count} أيام",
    interval: "كل يوم | كل {count} أيام",
    main: "لا يزال النزيل مقيمًا. مضى {since} دون تنظيف وحان موعده {interval}.",
  },

  // مؤقّت نافذة التنظيف
  timer: {
    approx: " (تقريبًا)",
    overdue: "تجاوز موعد الوصول",
    overdueTitle: "لقد فات وقت الوصول ({checkin}) · أعطِ الأولوية لهذا التنظيف",
    remaining: "{dur} حتى الوصول",
    remainingTitle: "يتبقى {dur} حتى الوصول ({checkin})",
  },

  // ── نافذة التذكيرات ──
  remind: {
    title: "تذكيرات التنظيف",
    subtitle: "نبّه فريقك عندما تكون غرفة قريبة من الوصول/المغادرة غير جاهزة.",
    close: "إغلاق",
    scopeLabel: "على أي عقارات؟",
    scopeOne: "هذا العقار",
    scopeAll: "الكل",
    summary: "{enabled} من {total} عقارات مفعّلة بها التذكيرات.",
    propertyLabel: "العقار",
    activeSuffix: " · مفعّل",
    propertyHelp: "كل عقار يحفظ جدوله الخاص.",
    allNotePre: "سيتم تطبيق الإعداد نفسه على ",
    allNotePost: " من عقاراتك (كل واحد بتوقيته المحلي).",
    arrivalsTitle: "الوصول والمغادرة",
    longStayTitle: "حجوزات الإقامة الطويلة",
    daysBeforeLabel: "قبل كم من الوقت؟",
    daysBefore: {
      same: "في اليوم نفسه فقط",
      upTo: "حتى {count} يوم مسبقًا | حتى {count} أيام مسبقًا",
    },
    daysBeforeHelp: "يعرض حالات الوصول/المغادرة ضمن هذه النافذة.",
    intervalLabel: "كل كم يوم يجب التنظيف؟",
    interval: "كل يوم | كل {count} أيام",
    intervalHelp: "يُحتسب منذ آخر تنظيف. ستظهر الغرفة ضمن «بحاجة إلى تنظيف» حتى لو كانت لا تزال مشغولة.",
    timeLabel: "في أي وقت تُرسل؟",
    timeHelp: "بالتوقيت المحلي للعقار. مرة واحدة يوميًا.",
    recipientsLabel: "من يتم تنبيهه؟",
    note: "تُرسل عبر قائمة انتظار (إشعار + إشعار فوري) ويُسجَّل كل تنبيه في الإشعارات.",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveAll: "الحفظ في الكل",
    save: "حفظ",
    recipients: {
      assigned: "المُسنَدون",
      team: "الفريق",
      both: "كلاهما",
    },
    recipientHelp: {
      assigned: "الأشخاص المُسنَدون إلى تلك الغرفة فقط.",
      team: "كامل فريق التنظيف/الصيانة في العقار.",
      both: "المُسنَدون وفريق العقار.",
    },
    longStayOff: "معطّلة",
    longStaySub: "كل يوم إقامة | كل {count} أيام إقامة",
    toggleAllOn: "ستُفعّل في الكل",
    toggleAllOff: "ستُعطّل في الكل",
    toggleOneOn: "مفعّلة لهذا العقار",
    toggleOneOff: "معطّلة",
  },

  // ── نافذة إكمال التنظيف ──
  complete: {
    title: "إكمال التنظيف",
    dropStrong: "اسحب الصور هنا",
    dropRest: "أو انقر للاختيار",
    dropHint: "دليل على حالة الغرفة · JPG، PNG، WEBP",
    photoAlt: "صورة",
    saved: "محفوظة",
    view: "عرض",
    remove: "إزالة",
    notes: "ملاحظات",
    notesPlaceholder: "مشكلات، أضرار، نواقص… (اختياري)",
    cancel: "إلغاء",
    uploading: "جارٍ الرفع… {pct}%",
    saving: "جارٍ الحفظ…",
    submit: "تعليم كنظيفة",
    previewAlt: "معاينة",
  },

  // ── نافذة الإسناد ──
  assignModal: {
    title: "من ينظّف هذه المساحة؟",
    allOption: "الجميع",
    allDesc: "يراها جميع موظفي التنظيف والصيانة",
    roleSection: "الإسناد إلى دور",
    peopleTitle: "أو اختر أشخاصًا",
    peopleHint: "(واحد أو أكثر)",
    emptyPre: "ليس لديك أعضاء فريق بعد. يمكنك الإسناد حسب الدور، أو إضافة أشخاص في ",
    emptyTeam: "الفريق",
    emptyPost: ".",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ الإسناد",
  },

  // ── التخطيط: تقويم أعمال التنظيف القادمة ──
  plan: {
    title: "تخطيط أعمال التنظيف",
    viewToday: "اليوم",
    viewPlan: "التخطيط",
    loading: "جارٍ تحميل التقويم…",
    loadError: "تعذّر تحميل التقويم.",
    saveError: "تعذّر الحفظ. حاول مرة أخرى.",
    empty: "لا توجد أعمال تنظيف في هذه التواريخ.",
    space: "المكان",
    prev: "الأيام السابقة",
    next: "الأيام التالية",
    today: "اليوم",
    days: "{n} أيام",
    anyone: "أي شخص",
    unassigned: "غير مُوكَلة",
    headline: {
      nothing: "لا يوجد شيء معلّق في هذه التواريخ.",
      all: "{total} عملية تنظيف معلّقة · {urgentes} عاجلة",
      withOrphans: "{total} معلّقة · {urgentes} عاجلة · {sin} غير مُوكَلة",
    },
    types: {
      turnover: "مغادرة ووصول",
      arrastre: "متأخرة",
      salida: "مغادرة",
      estancia: "إقامة طويلة",
      manual: "محدّدة يدويًا",
    },
    abbr: { all: "الكل", turnover: "تبديل", arrastre: "متأخر", salida: "مغادرة", estancia: "إقامة", manual: "يدوي" },
    windowGuessed: "أوقات افتراضية: هذا العقار لم تُحدَّد له أوقاته الخاصة",
    legendTight: "وقت ضيّق بين المغادرة والوصول",
    noRoomTip: "{n} مغادرات بدون غرفة مُحدّدة بعد",
    windowTip: "بين المغادرة ({desde}) والوصول ({hasta}) يوجد {min} دقيقة",
    roleShort: "دور",
    roleFull: "مُوكَلة إلى دور، لا إلى شخص",
    fromSpace: "إيكال ثابت للمكان",
    nobody: "غير مُوكَلة — اضغط لاختيار شخص",
    dow: { mon: "ن", tue: "ث", wed: "ر", thu: "خ", fri: "ج", sat: "س", sun: "ح" },

    teamRows: "توزيع الفريق",

    teamTitle: "الفريق",
    capacity: "الطاقة",
    capacityTitle: "كم عملية تنظيف يستطيع كل شخص إنجازها في اليوم",
    done: "تمّ",
    perDay: "في اليوم",
    dayOffTip: "تحديده يوم راحة",
    noStaff: "لا يوجد لديك طاقم تنظيف بعد. أضف أشخاصًا في الفريق وسيظهر هنا حجم عملهم.",
    shortHands: "تنقص الأيدي: {dias}",
    loadTip: "{dia}: {n} من {cap}",
    loadTipOff: "{dia}: يوم راحة ({n} مُوكَلة)",
    hasNow: "{n} مُوكَلة · يتحمّل {cap} في اليوم",

    selected: "{n} محدّدة",
    assignTo: "إيكال إلى…",
    assignBtn: "إيكال {n}",
    people: "الأشخاص",
    noteTitle: "ملاحظة لهذه العملية",
    notePlaceholder: "يصل متأخرًا، أعطِ الأولوية…",
    unassign: "إزالة",
    clear: "إلغاء التحديد",
    assigned: "تمّ إيكال {n} عملية تنظيف",
    unassigned2: "تمّت إزالة الإيكال",
    partial: "تمّ إيكال {n}، و{mal} لم تنجح",
    autoAssign: "توزيع تلقائي",
    nothingToAssign: "لا يوجد شيء غير مُوكَل في هذه التواريخ.",
    proposalTitle: "اقتراح التوزيع",
    proposalSub: "تمّ توزيع {n} عملية تنظيف. راجعها قبل التطبيق.",
    proposalApply: "تطبيق التوزيع",
    proposalUncovered: "{n} بدون تغطية",
    cancel: "إلغاء",
    uncovered: {
      nadie_tiene_esta_propiedad: "لا أحد لديه هذا العقار مُوكَلًا",
      nadie_trabaja_ese_dia: "لا أحد يعمل في ذلك اليوم",
      equipo_lleno: "الفريق وصل إلى حدّه",
    },
    rejected: {
      espacio_ajeno: "هذا المكان لا ينتمي إلى حسابك.",
      persona_ajena: "هذا الشخص ليس من فريقك.",
      persona_sin_la_propiedad: "هذا الشخص لا يملك هذا العقار مُوكَلًا إليه. أوكِله أولًا في الفريق.",
      rol_desconocido: "هذا الدور غير موجود.",
      datos_incompletos: "تنقص بيانات عملية التنظيف.",
      error_al_guardar: "تعذّر الحفظ.",
    },
    autoAssignN: "توزيع {n}",
    seeDay: "عرض اليوم",
    filtering: "تصفية حسب",
    showingOf: "يُعرض {n} من {total}",
    emptyFiltered: "لا نتائج بهذه التصفية. هناك {total} عملية تنظيف في هذه التواريخ.",
    moreFilters: "مزيد من عوامل التصفية",
    roomy: "مريح",
    dense: "مضغوط",
    ofN: "من {n} عملية تنظيف",
    addPerson: "إضافة شخص إلى الفريق",
    notCleaner: "ليس من طاقم التنظيف، لكن لديه عمل مُوكَل",
    teamCap: "{n} في اليوم",
    teamFoot: "حجم العمل يخصّ المدة كلها؛ عوامل التصفية لا تغيّره.",
    perDayN: "{n} في اليوم",
    closedN: "{n} مُغلقة",
    capMax: "الحدّ الأقصى {n} في اليوم",
    rowHint: "Alt + نقر لاختيار الصف كاملًا",
    daySheetTip: "اضغط لعرض اليوم · Alt + نقر لاختياره كاملًا",
    keysHint: "1-9 للإيكال · A للفتح · Esc للمسح",
    undo: "تراجع",
    undone: "أُعيد التوزيع",
    tightDay: "{dia} فيه {n} عملية تنظيف",
    tightMore1: "ويوم آخر",
    tightMoreN: "و{n} أيام أخرى",
    proposalDetail: "عرض التوزيع عملية بعملية",
    nobody2: "لا أحد بعد",
    warnDayOff: "{quien} في راحة يوم {dia}.",
    warnOver: "{quien} يصل إلى {n} في {dia} ويتحمّل {cap}.",
    onDay: "{dia}: {n} + {mas} من {cap}",
    onDays: "{dias} أيام: {n} من {cap}",
    c: { pending: "معلّقة", urgent: "عاجلة", tight: "أيام مزدحمة", done: "منجزة", noRoom: "بدون غرفة" },
    rows: {
      withWork: "فيها عمل",
      all: "الكل",
      help: "«الكل» يعرض أيضًا الأماكن التي لا تحتاج تنظيفًا في هذه التواريخ.",
      forced: "مع تفعيل التصفية تُعرض فقط الأماكن التي فيها عمل.",
    },
    f: {
      any: "أي",
      urgency: "الاستعجال",
      window: "النافذة",
      state: "الحالة",
      unitType: "نوع المكان",
      clear: "مسح عوامل التصفية",
    },
    urg: {
      urgente: "يصل أحد في اليوم نفسه",
      alta: "يصل في اليوم التالي",
      normal: "يصل خلال يومين أو ثلاثة",
      baja: "لا يصل أحد بعده",
    },
    holg: { amplia: "واسعة", justa: "ضيّقة", imposible: "الوقت لا يكفي" },
    estados: { pendiente: "معلّقة", en_curso: "قيد التنفيذ", hecha: "منجزة", fuera_de_servicio: "خارج الخدمة" },
    motivos: {
      faltan_manos: "تنقص أيدٍ لـ {n}",
      con_hora_limite: "{n} بموعد نهائي",
      varios_edificios: "{n} مبانٍ مختلفة",
    },
    sheet: {
      autoDay: "توزيع هذا اليوم",
      assignAll: "إيكال الـ {n} كلها",
      nCleanings: "{n} عملية تنظيف",
      nUnassigned: "{n} غير مُوكَلة",
      covers: "الفريق يغطّي {n}",
      empty: "لا شيء للتنظيف في هذا اليوم.",
    },
    tip: {
      outIn: "مغادرة · وصول",
      lateSold: "مغادرة متأخرة مُباعة",
      earlySold: "وصول مبكّر",
      noName: "بدون اسم",
      pax: "{n} أشخاص",
      nights: "{n} ليالٍ",
      min: "{n} دقيقة",
      h: "{h} ساعة",
      hm: "{h} ساعة {m}",
      stillIn: "ما زال مقيمًا",
      freeNobody: "يبقى فارغًا",
      freeNone: "يدخل غيره",
      freeDay1: "فارغ يوم واحد",
      freeDaysN: "فارغ {n} أيام",
      houseHours: "أوقات افتراضية",
      openSpace: "بطاقة المكان", openSpaceHint: "تُفتح في لوحة اليوم، مع حالتها ومهامها وسجلّها",
      select: "اختيار",
      deselect: "إزالة من التحديد",
      assignedBy: "أوكَلها {quien}",
    },
  },
};
